import OSfIncomingCallModal from './index.vue';

OSfIncomingCallModal.install = app => {
  app.component(OSfIncomingCallModal.name, OSfIncomingCallModal);
};

export default OSfIncomingCallModal;
